export default "__VITE_ASSET__Da4fCtZ2__"